import ListeTargetare from "@/pages/AdministrareTargetare/pagini/ListeTargetare";

export default function ListeOficiale() {
  return <ListeTargetare tipFiltru="OFICIALA" />;
}
